@switch (type) {

  @case ('thinking') {
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="-12 -12 24 24"
         [attr.width]="size"
         [attr.height]="size"
         class="ai-thinking"
         [style.animation-delay]="animationDelay">
      <defs>
        <filter id="thinking-glow">
          <feGaussianBlur stdDeviation="0.8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g class="ai-thinking-sparkle" filter="url(#thinking-glow)" [style.animation-delay]="pulseDelay">
        <path
          [attr.fill]="color"
          d="M0,-8 C1,-3 3,-1 8,0 C3,1 1,3 0,8 C-1,3 -3,1 -8,0 C-3,-1 -1,-3 0,-8Z" />
      </g>
      <circle class="ai-thinking-dot ai-thinking-dot-1" [attr.fill]="color" r="1" cx="0" cy="0" [style.animation-delay]="orbitDelay" />
      <circle class="ai-thinking-dot ai-thinking-dot-2" [attr.fill]="color" r="0.7" cx="0" cy="0" [style.animation-delay]="orbitDelay" />
      <circle class="ai-thinking-dot ai-thinking-dot-3" [attr.fill]="color" r="0.5" cx="0" cy="0" [style.animation-delay]="orbitDelay" />
    </svg>
  }

  @case ('waiting') {
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="-12 -12 24 24"
         [attr.width]="size"
         [attr.height]="size">
      <defs>
        <filter id="waiting-glow">
          <feGaussianBlur stdDeviation="1" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <circle
        class="ai-waiting-dot"
        filter="url(#waiting-glow)"
        [attr.fill]="color"
        r="3"
        cx="0" cy="0"
        [style.animation-delay]="pulseDelay" />
    </svg>
  }

  @case ('bid') {
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="0 0 24 24"
         [attr.width]="size"
         [attr.height]="size"
         style="overflow: visible">
      <g class="ai-bid-badge" [style.animation-delay]="pulseDelay">
        <!-- Starburst badge -->
        <path
          [attr.fill]="color"
          d="M12,2 L14.1,5.1 L17.6,3.8 L17.8,7.5 L21.5,8.2 L19.8,11.5 L22.4,14 L19.3,16 L20.2,19.6 L16.6,19.6 L15.2,23 L12,21 L8.8,23 L7.4,19.6 L3.8,19.6 L4.7,16 L1.6,14 L4.2,11.5 L2.5,8.2 L6.2,7.5 L6.4,3.8 L9.9,5.1Z" />
        <!-- Dollar sign (transparent cutout) -->
        <text
          x="12" y="12.5"
          text-anchor="middle"
          dominant-baseline="central"
          fill="var(--tidy-bg-primary)"
          font-size="11"
          font-weight="700"
          font-family="system-ui, -apple-system, sans-serif">$</text>
      </g>
    </svg>
  }

  @case ('accepted') {
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="-12 -12 24 24"
         [attr.width]="size"
         [attr.height]="size">
      <defs>
        <filter id="accepted-glow">
          <feGaussianBlur stdDeviation="0.8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g class="ai-accepted-check" filter="url(#accepted-glow)" [style.animation-delay]="pulseDelay">
        <polyline
          points="-5,1 -1.5,5 5.5,-4"
          [attr.stroke]="color"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
          fill="none" />
      </g>
    </svg>
  }

  @case ('canceled') {
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="-12 -12 24 24"
         [attr.width]="size"
         [attr.height]="size">
      <defs>
        <filter id="canceled-glow">
          <feGaussianBlur stdDeviation="0.8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g class="ai-canceled-alert" filter="url(#canceled-glow)" [style.animation-delay]="pulseDelay">
        <line x1="0" y1="-5.5" x2="0" y2="1.5" [attr.stroke]="color" stroke-width="2.5" stroke-linecap="round" />
        <circle cx="0" cy="5" r="1.3" [attr.fill]="color" />
      </g>
    </svg>
  }

  @case ('failed') {
    <svg xmlns="http://www.w3.org/2000/svg"
         viewBox="-12 -12 24 24"
         [attr.width]="size"
         [attr.height]="size">
      <defs>
        <filter id="failed-glow">
          <feGaussianBlur stdDeviation="0.8" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g class="ai-failed-x" filter="url(#failed-glow)" [style.animation-delay]="pulseDelay">
        <line x1="-5" y1="-5" x2="5" y2="5" [attr.stroke]="color" stroke-width="2.5" stroke-linecap="round" />
        <line x1="5" y1="-5" x2="-5" y2="5" [attr.stroke]="color" stroke-width="2.5" stroke-linecap="round" />
      </g>
    </svg>
  }

}
